import React from "react";
import { Box } from "@mui/material";
import { CarriersRepDirectory } from "@platform/carriers-rep-directory";

export const CarriersRepDirectoryPage: React.FC = () => (
  <Box height="100vh" display="flex" flexDirection="column" p={3} pt={12}>
    <CarriersRepDirectory />
  </Box>
);
